import React, { Component } from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu/modules";
import InlineEdit from './InlineEdit';

class MenuNode extends Component {

	render() {
		const { label, id, handlePeer, handleAdd, handleDelete, dataChanged, handleDnD } = this.props;

		const dragstart_handler = function (ev) {
			ev.dataTransfer.setData("text/plain", ev.target.id);
		}

		function dragover_handler(ev, data) {
			ev.preventDefault();
			ev.dataTransfer.dropEffect = "move"
		}

		function drop_handler(ev, data) {
			ev.preventDefault();
			const sourceId = ev.dataTransfer.getData("text/plain");
			handleDnD(sourceId, id);
		}

		return (
			<div>
				<ContextMenu id={`contextMenu_${id}`}>
					<MenuItem data={{ id }} onClick={handlePeer}>
						Add Peer
                      </MenuItem>
					<MenuItem data={{ id }} onClick={handleAdd}>
						Add Child
                      </MenuItem>
					<MenuItem divider />
					<MenuItem data={{ id }} onClick={handleDelete}>
						Remove Element
                      </MenuItem>
				</ContextMenu>
				<ContextMenuTrigger id={`contextMenu_${id}`}>
					<div className="well" id={id.toString()} onDrop={drop_handler} onDragOver={dragover_handler} draggable="true" onDragStart={dragstart_handler}>
						<InlineEdit
							activeClassName="editing"
							text={label}
							paramName="message"
							data={{ id }}
							change={dataChanged}
							style={{
								minWidth: 150,
								display: 'inline-block',
								margin: 0,
								padding: 0,
								fontSize: 15,
								outline: 0,
								border: 0
							}}
						/>
					</div>
				</ContextMenuTrigger>
			</div>
		);
	};
}

export default MenuNode;